import { Profile } from "../../../types";
import { formatPhoneNumber } from "@/utils/format";
import { Button } from "@/components/ui/button";
import { Pencil } from "lucide-react";
import { ResetPasswordDialog } from "../../../../contact/ResetPasswordDialog";

interface ContactDisplayProps {
  profile: Profile;
  onEdit: () => void;
}

export const ContactDisplay = ({ profile, onEdit }: ContactDisplayProps) => {
  return (
    <div className="space-y-6 mt-6 animate-fade-up">
      <div className="flex justify-end mb-4">
        <Button variant="outline" size="sm" onClick={onEdit}>
          <Pencil className="h-4 w-4 mr-2" />
          Edit
        </Button>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 text-lg">
        <div className="p-4 bg-white/50 rounded-lg border border-purple-100/30 hover:shadow-md transition-all duration-300">
          <h3 className="text-sm font-medium text-primary">Name</h3>
          <p className="mt-1 text-sm text-primary-dark">
            {profile.first_name} {profile.last_name}
          </p>
        </div>
        <div className="p-4 bg-white/50 rounded-lg border border-purple-100/30 hover:shadow-md transition-all duration-300">
          <h3 className="text-sm font-medium text-primary">Email</h3>
          <p className="mt-1 text-sm text-primary-dark">{profile.email}</p>
        </div>
        <div className="p-4 bg-white/50 rounded-lg border border-purple-100/30 hover:shadow-md transition-all duration-300">
          <h3 className="text-sm font-medium text-primary">Phone</h3>
          <p className="mt-1 text-sm text-primary-dark">{formatPhoneNumber(profile.phone)}</p>
        </div>
        <div className="p-4 bg-white/50 rounded-lg border border-purple-100/30 hover:shadow-md transition-all duration-300">
          <h3 className="text-sm font-medium text-primary">Address</h3>
          <p className="mt-1 text-sm text-primary-dark">
            {profile.street && profile.city && profile.state && profile.zip_code
              ? `${profile.street}, ${profile.city}, ${profile.state} ${profile.zip_code}`
              : "N/A"}
          </p>
        </div>
      </div>
      <div className="flex justify-end">
        <ResetPasswordDialog userId={profile.id} userEmail={profile.email || ''} />
      </div>
    </div>
  );
};